import React from 'react';
import PropTypes from 'prop-types';

import Input from '../../../components/Input/Input';
import Text from '../../../components/Text/Text';
import Card from '../../../components/Card/Card';

const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';
const inputClassName = 'py-[8px] px-[13px]';

const ArticlesSEO = ({
  handleChange, handleBlur, errors, touched, values
}) => {
  const {
    metaTitle, metaDescription
  } = values;

  return (
    <Card
      headerTitle="SEO Data:"
      showHeader
      styleBodyContainer={cardBodyClassName}
      styleContainer={cardContainerClassName}
      headerBordered={false}
      required
    >
      <Text text="Meta title:" muted required />
      <Input
        type="text"
        name="metaTitle"
        value={metaTitle}
        placeholder="Article meta title"
        onBlur={handleBlur}
        onChange={handleChange}
        errorText={touched.metaTitle && errors?.metaTitle}
        inputStyle={inputClassName}
      />
      <Text text="Meta description:" muted required />
      <Input
        type="text"
        name="metaDescription"
        value={metaDescription}
        placeholder="Meta description"
        onBlur={handleBlur}
        onChange={handleChange}
        errorText={touched.metaDescription && errors?.metaDescription}
        inputStyle={inputClassName}
        multiline
      />
    </Card>
  );
};

ArticlesSEO.propTypes = {
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  errors: PropTypes.shape({
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
  }),
  touched: PropTypes.shape({
    metaTitle: PropTypes.bool,
    metaDescription: PropTypes.bool,
  }),
  values: PropTypes.shape({
    metaTitle: PropTypes.string,
    metaDescription: PropTypes.string,
  }),
};

ArticlesSEO.defaultProps = {
  handleChange: () => {},
  handleBlur: () => {},
  errors: null,
  touched: null,
  values: {}
};

export default ArticlesSEO;
